import settings from "@/core/settings"
import { SearchTrackOptions } from "./types"

export function isFeatureEnabled(type: SearchTrackOptions) {
  if (type === "category") {
    return settings.categoriesEnabled
  } else {
    return settings.searchEnabled
  }
}
